import React from "react";
import {Map, GoogleApiWrapper, Marker} from 'google-maps-react';
import "./c77_convenzioni_details.scss";
import TemplateComponent from "../../containers/template_page/template_component/template_component";

export class MapContainer extends TemplateComponent {

    constructor(props) {
        super(props);
        this.requireInternationalization = true;
    }

    internationalComponentRender(allData, t) {

        const data = this.props.data;
        const cardCategory = data.tag_convention

        const mapStyles = {
            width: '100%',
            height: '100%',
        };
        const containerStyle = {
            position: 'relative',
            width: '100%',
            height: '100%'
        }

        let min_discount;
        let max_discount;

        if (!allData.min_discount) {
            min_discount = allData.max_discount;
            max_discount = false;
        } else {
            min_discount = allData.min_discount;
            max_discount = allData.max_discount;
        }

        return (
            <div id="google-wrapper-contenzioni">
                <div className="container-fluid">
                    {(cardCategory && cardCategory.label)? <div className="row">
                        <div className='text-category-color row-details'>{cardCategory.label}</div>
                    </div> : null}
                    {min_discount || max_discount ? <div className="row">
                        <div className=' text-discount row-details'>{t("C75 Discount label")} : {min_discount}% {max_discount ? `- ${max_discount}%` : null}</div>
                    </div> : null}
                    {data.phone || data.fax || data.email || data.link_convenzione || data.address ? <div className="row">
                        <div className='text-contacts row-details'>{t("C77 Contacts")}</div>
                    </div> : null}
                    {data.phone ? <div className="row">
                        <div className='contact-details row-details'><em>{t("C77 Phone")}: {data.phone}</em></div>
                    </div> : null}
                    {data.fax ? <div className="row">
                        <div className='contact-details row-details'><em>{t("C77 Fax")}: {data.fax}</em></div>
                    </div> : null}
                    {data.email ? <div className="row">
                        <div className='contact-details row-details'><em>{t("C77 Email")}: {data.email}</em></div>
                    </div> : null}
                    {data.link_convenzione ? <div className="row">
                        <div className='contact-details row-details'>
                            <em>{t("C77 Website")}:
                                <a href={data.link_convenzione} target="_blank" rel="noopener noreferrer">{data.link_convenzione_title ? data.link_convenzione_title : data.link_convenzione}</a>
                            </em>
                        </div>
                    </div> : null}
                    {data.address ? <div className="row">
                        <div className='contact-details row-details'><em>{t("C77 Address")}: {data.address}</em></div>
                    </div> : null}
                    <div className="row">
                        <div className='mb-4'/>
                    </div>
                </div>
                {data.lat && data.lng && data.lat !== 0 && data.lng !== 0 ?
                    <div className="google-wrapper mb-5">
                        <Map google={this.props.google} zoom={18} style={mapStyles} containerStyle={containerStyle} initialCenter={{lat: data.lat, lng: data.lng}}>
                            <Marker position={{lat: data.lat, lng: data.lng}}/>
                        </Map>
                    </div> : null}
            </div>
        );
    }
}

export default GoogleApiWrapper(
    (props) => ({
            apiKey: 'AIzaSyC8foqBVORUNZmk1RhGs0n8k5uK1RoLZRI'
        }
    ))(MapContainer)
